import React from 'react';
import { simpleIconPropsTypes } from '../propTypes';

export const IconTag = (props) => {
  const { width, height, color = '#292D32' } = props;

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.17038 15.3L8.70038 19.83C10.5604 21.69 13.5804 21.69 15.4504 19.83L19.8404 15.44C21.7004 13.58 21.7004 10.56 19.8404 8.69005L15.3004 4.17005C14.3504 3.22005 13.0404 2.71005 11.7004 2.78005L6.70038 3.02005C4.70038 3.11005 3.11038 4.70005 3.01038 6.69005L2.77038 11.69C2.71038 13.04 3.22038 14.35 4.17038 15.3Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 12.0001C10.8807 12.0001 12 10.8808 12 9.50006C12 8.11935 10.8807 7.00006 9.5 7.00006C8.11929 7.00006 7 8.11935 7 9.50006C7 10.8808 8.11929 12.0001 9.5 12.0001Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

IconTag.propTypes = simpleIconPropsTypes;
